// extracted by mini-css-extract-plugin
export var box = "_23-1";
export var checkboxRow = "_23-8";
export var checked = "_23-2";
export var descriptionSpacer = "_23-a";
export var disabled = "_23-3";
export var icon = "_23-6";
export var input = "_23-0";
export var labelSpacer = "_23-9";
export var medium = "_23-5";
export var small = "_23-4";
export var text = "_23-7";